<template>
    <div class="slide thank-you">

        <div class="thank-you-content" v-if="wantPlanner">

            <div class="text-title">
                I have already started <span>building your plan</span>,
                <br>
                would you like to see where we are so far?
            </div>

            <div class="buttons">
                <button class="btn-yes" @click="goToIncomePlanner">Yes, I would like to see my plan</button>
                <button class="btn-no" @click="wantPlanner = false">No, I am ok</button>
            </div>

        </div>

        <div class="thank-you-content" v-if="!wantPlanner">

            <div class="text-title">
                Would you feel more comfortable
                <br>
                <span>talking to someone</span>?
            </div>

            <div class="description">
               If you want, speak with a licensed financial advisor to discuss your particular situation and what might be the best approach for your investment strategy and provide a convenient time for us to call to schedule our meeting.
            </div>

            <div class="buttons display-flex-col">
                <button class="btn-yes" @click="alert('do something here...')">Yes, I would like to speak to an advisor</button>
                <button class="btn-no" @click="wantPlanner = true">No, thank you</button>
            </div>

        </div>

    </div>
</template>

    <script>
    import {mapGetters} from "vuex";

    export default {
        name: 'ThankYou',
        data() {
          return {
              wantPlanner:true,
              wantAdvisor:true
          }
        },
        methods: {
          goToIncomePlanner() {
              window.location = process.env.VUE_APP_BASE_URL + '/households/'+ this.user.household_id +'/year-to-date';
          }
        },
        computed: {
            ...mapGetters('auth', [
                'user',
            ]),
        }
    }
</script>
